module.exports = __webpack_public_path__ + "img/Monitor1.4d6ee78b.png";